// @flow

export const LOGIN = "/login"
export const HOME = "/"
export const DASHBOARD = "/dashboard"
export const CLIENT = "/client"
export const CLIENTS = "/clients"
export const APPOINTMENTS = "/appointments"
export const APPOINTMENT = "/appointments/:date/:institution/:id"